import {AxiosResponse} from "axios";
import axios from "../api-instance";
import ENDPOINTS from "../consts/endpoints";
import {AddGroupCourseArgs, AddGroupUserArgs, CreateGroupArgs, EditGroupArgs, IGroup } from "../common/group";

export type IGroupsRepository = {
    getGroups: Function;
    getGroupUsers: Function;
    addGroup: Function;
    deleteGroup: Function;
    editGroup: Function;
    addGroupUser: Function;
    deleteGroupUser: Function;
    getGroupCourses: Function;
    deleteGroupCourse: Function;
    addGroupCourse: Function;
};

class GroupsRepository implements IGroupsRepository {
    private api = axios;
    private getData(response: AxiosResponse) {
        return response.data;
    }
    getGroups() {
        this.api.setHeaders();
        return this.api.get(ENDPOINTS.GROUPS).then(this.getData);
    }
    getGroupUsers(groupId: IGroup['id']) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.GROUPS}/${groupId}/users`).then(this.getData);
    }
    addGroupUser({id, userId}: AddGroupUserArgs) {
        this.api.setHeaders();
        return this.api.put(`${ENDPOINTS.GROUPS}/${id}/users/${userId}`).then(this.getData);
    }
    deleteGroupUser({id, userId}: AddGroupUserArgs) {
        this.api.setHeaders();
        return this.api.delete(`${ENDPOINTS.GROUPS}/${id}/users/${userId}`).then(this.getData);
    }
    addGroup(data: CreateGroupArgs){
        this.api.setHeaders();
        return this.api.post(ENDPOINTS.GROUPS, data).then(this.getData);
    }
    deleteGroup(groupId: IGroup['id']) {
        this.api.setHeaders();
        return this.api.delete(`${ENDPOINTS.GROUPS}/${groupId}`).then(this.getData);
    }
    editGroup({id, newName}: EditGroupArgs) {
        this.api.setHeaders();
        return this.api.put(`${ENDPOINTS.GROUPS}/${id}`, {newName}).then(this.getData);
    }
    getGroupCourses(id: IGroup['id']) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.GROUPS}/${id}/courses`).then(this.getData)
    }
    addGroupCourse({id, courseId}: AddGroupCourseArgs) {
        this.api.setHeaders();
        return this.api.put(`${ENDPOINTS.GROUPS}/${id}/courses/${courseId}`).then(this.getData);
    }
    deleteGroupCourse({id, courseId}: AddGroupCourseArgs) {
        this.api.setHeaders();
        return this.api.delete(`${ENDPOINTS.GROUPS}/${id}/courses/${courseId}`).then(this.getData);
    }
};

export default GroupsRepository;
